class DoctorSplitShiftStrategy {
     calculateAttendance(employee, attendanceData) {
          console.log('🩺 Doctor Split Shift Strategy - Calculating attendance for:', employee.employee_name);

          const {
               shift_description_1,
               shift_description_2,
               in_time_1,
               out_time_1,
               in_time_2,
               out_time_2,
               total_hours,
               WorkingsHoursToBeConsiderdFullDay,
               WorkingsHoursToBeConsiderdHalfDay
          } = attendanceData;

          // Validate both shifts are present
          if (!shift_description_1 || !shift_description_2) {
               console.warn('⚠️ Split shift configuration incomplete');
               return { status: 'A', remarks: 'Split shift not configured' };
          }

          // Check if both shifts have attendance
          const hasFirstShift = in_time_1 && out_time_1;
          const hasSecondShift = in_time_2 && out_time_2;

          if (!hasFirstShift && !hasSecondShift) {
               return { status: 'A', remarks: 'Absent - No attendance in both shifts' };
          }

          // Parse total hours
          const hoursWorked = parseFloat(total_hours) || 0;
          const fullDayHours = parseFloat(WorkingsHoursToBeConsiderdFullDay) || 8;
          const halfDayHours = parseFloat(WorkingsHoursToBeConsiderdHalfDay) || 4;

          // Determine attendance status
          if (hoursWorked >= fullDayHours) {
               return {
                    status: 'P',
                    remarks: `Present - Split Shift (${shift_description_1}, ${shift_description_2})`
               };
          } else if (hoursWorked >= halfDayHours) {
               return {
                    status: 'HD',
                    remarks: `Half Day - Split Shift (${hoursWorked.toFixed(2)} hours)`
               };
          } else if (hoursWorked > 0) {
               return {
                    status: 'HD',
                    remarks: `Half Day - Incomplete split shift (${hoursWorked.toFixed(2)} hours)`
               };
          } else {
               return { status: 'A', remarks: 'Absent - No valid working hours' };
          }
     }

     // Wrapper so EmployeeAttendance can call calculateAttendanceStatus(...)
     calculateAttendanceStatus(day, roster, holidays, employeeData) {
          // If roster or day explicitly marks a custom weekoff => return Week Off
          const isWeekOff = Boolean(roster?.custom_weekoff_date) || (Array.isArray(day.shifts) && day.shifts.some(s => Boolean(s.custom_weekoff_date)));
          if (isWeekOff) {
               return {
                    status: "Week Off",
                    lateMark: "-",
                    workingHours: "-",
                    statusColor: "#60a5fa",
                    remarks: "Week Off"
               };
          }

          const shift1 = (day.shifts || []).find(s => s.split_shift_type === 'shift_1') || {};
          const shift2 = (day.shifts || []).find(s => s.split_shift_type === 'shift_2') || {};
          const totalWorkedSeconds = (shift1.worked_seconds || 0) + (shift2.worked_seconds || 0);
          const totalHoursDecimal = totalWorkedSeconds / 3600;

          const raw = this.calculateAttendance(employeeData || {}, {
               shift_description_1: shift1.shift_name,
               shift_description_2: shift2.shift_name,
               in_time_1: shift1.in_time,
               out_time_1: shift1.out_time,
               in_time_2: shift2.in_time,
               out_time_2: shift2.out_time,
               total_hours: totalHoursDecimal.toFixed(2),
               WorkingsHoursToBeConsiderdFullDay: roster?.total_hours || 8,
               WorkingsHoursToBeConsiderdHalfDay: roster?.WorkingsHoursToBeConsiderdHalfDay || 4
          });

          const formatSeconds = secs => {
               if (!secs) return "-";
               const h = Math.floor(secs / 3600);
               const m = Math.floor((secs % 3600) / 60);
               const s = secs % 60;
               return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
          };

          let status = "Absent";
          let statusColor = "#ef4444";
          let lateMark = "-";
          let workingHours = totalWorkedSeconds ? formatSeconds(totalWorkedSeconds) : "-";

          if (raw.status === "P") {
               status = "Present";
               statusColor = "#10b981";
          } else if (raw.status === "HD") {
               status = "Half Day";
               statusColor = "#f59e0b";
          } else if (raw.status === "A") {
               status = "Absent";
               statusColor = "#ef4444";
          } else {
               status = raw.status || status;
          }

          return {
               status,
               lateMark,
               workingHours,
               statusColor,
               remarks: raw.remarks || ""
          };
     }
}

export default DoctorSplitShiftStrategy;